<template>
  <table>
    <tr style="font-size: medium">
      <td>
        <span class="badge" style="color: black; background: white"
          >Estado:
        </span>
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: white;
          "
          >A tratar</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: rgb(162, 255, 134, 0.5);
          "
          >Resueltos</span
        >
      </td>
    </tr>
  </table>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "ReferenciaDeColoresHistorial",
});
</script>
